"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseBannerComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var license_banner_style_1 = require("../../components/license.banner/license.banner.style");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var icon_1 = require("../icon");
var icons_1 = require("../icon/icons");
var mithril_component_1 = require("../mithril.component");
var LicenseBannerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LicenseBannerComponent, _super);
    function LicenseBannerComponent() {
        var _this = _super.call(this) || this;
        _this.name = 'LicenseBanner';
        _this.bannerVisible = false;
        (0, mobx_1.autorun)(function () {
            _this.bannerVisible = services_1.Services.License.hasNoLicense;
        });
        return _this;
    }
    LicenseBannerComponent.prototype.onremove = function () {
        if (this.disposer) {
            this.disposer();
        }
    };
    Object.defineProperty(LicenseBannerComponent.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.bannerVisible) {
                return (0, mithril_1.m)('div', { className: license_banner_style_1.CSS.alert }, [
                    (0, mithril_1.m)('span', { className: license_banner_style_1.CSS.License }, [
                        (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_TEXT),
                        (0, mithril_1.m)('a', { className: license_banner_style_1.CSS.alertHref, href: 'https://ikegps.zendesk.com/hc/en-us/articles/24400055764237-How-to-Admin-IKE-Office-Pro-User-Seats-Using-IKE-Access-FAQ', target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_LINK)),
                        '.'
                    ]),
                    (0, mithril_1.m)('span', { className: license_banner_style_1.CSS.License }, [
                        (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT),
                        (0, mithril_1.m)('a', { className: license_banner_style_1.CSS.alertHref, href: "mailto:".concat((0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)) }, (0, i18n_1.Translate)(i18n_1.T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL)),
                        '.'
                    ]),
                    (0, mithril_1.m)('button', {
                        className: license_banner_style_1.CSS.closeButton,
                        onclick: function () {
                            services_1.Services.License.hasNoLicense = false;
                            _this.bannerVisible = false;
                        },
                        title: i18n_1.T.CLOSE
                    }, [
                        (0, i18n_1.Translate)(i18n_1.T.DISMISS),
                        icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, {
                            className: license_banner_style_1.CSS.closeIcon
                        })
                    ])
                ]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], LicenseBannerComponent.prototype, "bannerVisible", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], LicenseBannerComponent.prototype, "nodes", null);
    return LicenseBannerComponent;
}(mithril_component_1.IMithrilComponent));
exports.LicenseBannerComponent = LicenseBannerComponent;
//# sourceMappingURL=license.banner.js.map